export default {
  lgpd: {
    text1:
      'We use cookies to collect information about how you interact with our website, allowing us to improve and personalize your browsing experience, and perform analysis and metrics on our visitors. For further information, please read our',
    link: 'Privacy Policy',
    text2: 'By clicking “I Agree”, you accept the use of these cookies.',
    buttonContent: 'I agree',
  },
}
